<template>
  <div
    v-editable="blok"
    class="HotSpotText"
  >
    <div class="HotSpotTextWrap p-8 desk:p-20 flex flex-col gap-0 desk:gap-12">
      <div class="wysiwyg">
        <ExtendedWysiwyg :content="blok.content" />
      </div>
      <nuxt-link
        v-if="blok.buttonText"
        :to="$sbLinkFix(blok.buttonLink)"
        :target="$sbLinkTarget(blok.buttonLink)"
      >
        <div
          class="btn"
          :class="{
            'btn--secondary' : blok.buttonStyle === 'secondary',
            'btn--underline' : blok.buttonStyle === 'underline',
          }"
        >
          {{ blok.buttonText }}
        </div>
      </nuxt-link>
    </div>
  </div>
</template>

<script setup lang="ts">

import {
  StoryBlokLink,
  StoryBlokPropBase
} from '~/constants/types/storyblok';
import { ISbRichtext } from 'storyblok-js-client';

type Props = StoryBlokPropBase & {
  content: ISbRichtext;
  buttonText: string;
  buttonStyle: 'primary' | 'secondary' | 'underline';
  buttonLink: StoryBlokLink;
}

const props = defineProps<{
  blok: Props,
}>();

</script>

<style scoped lang="postcss">
:deep(.wysiwyg h2) {
  @apply text-20 desk:text-28 leading-26 desk:leading-36;
}
</style>
